import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "36",
      height: "36",
      fill: "#f8f8f8",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#60bd3f",
      d: "m18.856 18.458-8.502 7.97V10.471l8.502 7.986Zm2.996 2.897-10.13 5.336c0 .012-.007.017-.02.017h-.037c-.012-.011-.021-.017-.028-.017-.006 0-.015-.006-.028-.018 0-.011-.003-.02-.01-.026-.005-.006-.002-.015.01-.026v-.035c0-.012.006-.018.019-.018l7.884-7.408 2.34 2.195Zm-2.34-3.599-7.884-7.407c-.013 0-.019-.006-.019-.018v-.035c-.012-.012-.015-.02-.01-.026.007-.006.01-.015.01-.027.013-.011.022-.017.028-.017.006 0 .016-.006.028-.018h.038c.012 0 .019.006.019.018l10.13 5.336-2.34 2.194Zm7.134.702c0 .106-.05.214-.15.325-.1.111-.237.214-.412.307l-3.333 1.79-2.584-2.422 2.584-2.422 3.333 1.773a1.8 1.8 0 0 1 .412.325c.1.11.15.22.15.324Z"
    }, null, -1)
  ]))]))
}
export default { render: render }